/*
 *
 * Estas librerias estan presentes tanto en la website como en el dashboard
 *
 */

//Librerias necesarias
import VeeValidate, { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es';
import vSelect from 'vue-select';
import vueTopprogress from 'vue-top-progress';
// Vue2Editor movido a componentes específicos que lo usan (lazy loading)
import QRCode from 'qrcode';
//Funcion para añadirlas a Vue
function fire(Vue){
	//Vee-validate
	Validator.localize('es', es);
	Vue.use(VeeValidate,{locale:"es"});
	//Vue-select
	Vue.component('v-select', vSelect);
	//Loading bar
	Vue.use(vueTopprogress);
	//QRCode
	Vue.component('qrcode', QRCode);
}

export default fire;
